<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            :range="true"
            label="평가기간"
            name="assessmentDates"
            v-model="searchParam.assessmentDates"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            codeGroupCd="RAM_ASSESS_TYPE_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="ramAssessTypeCd"
            label="평가구분-정기/수시/최초"
            v-model="searchParam.ramAssessTypeCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            :comboItems="stepItems"
            type="search"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="ramStepCd"
            label="진행단계"
            v-model="searchParam.ramStepCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="tasktable"
      title="위험성평가 목록"
      :columns="grid.columns"
      :data="grid.data"
      :columnSetting="false"
      :isFullScreen="false"
      :usePaging="false"
      :expandAll="true"
      selection="multiple"
      rowKey="ramRiskAssessmentPlanId"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn
            v-if="editable"
            label="삭제"
            icon="remove"
            @btnClicked="deleteTask"
          />
          <c-btn
            v-if="editable"
            label="추가"
            icon="add"
            @btnClicked="addTask"
          />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "constructionRelactionTaskRiskAssess",
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        sopConstructionId: "",
      }),
    },
    task: {
      type: Object,
      default: () => ({
        insertUrl: "",
        deleteUrl: "",
      }),
    },
  },
  data() {
    return {
      searchParam: {
        plantCd: null,
        assessmentDates: [],
        ramAssessTypeCd: null,
        ramStepCd: null,
        ramTechniqueCd: "",
        // isVendor: true,
        approvalUserId: "",
        sopConstructionId: "",
        constructionFlag: true,
      },
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "사업장",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "ramTechniqueName",
            field: "ramTechniqueName",
            label: "평가기법",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "assessmentName",
            field: "assessmentName",
            label: "평가명",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "link",
          },
          {
            name: "ramStepName",
            field: "ramStepName",
            label: "진행단계",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "assessmentDate",
            field: "assessmentDate",
            label: "평가기간",
            align: "center",
            style: "width:150px",
            sortable: true,
          },
          {
            name: "ramAssessTypeName",
            field: "ramAssessTypeName",
            label: "평가구분",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "regUserName",
            field: "regUserName",
            label: "작성자",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "reviewUserName",
            field: "reviewUserName",
            label: "검토자",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "approvalUserName",
            field: "approvalUserName",
            label: "승인자",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
        ],
        data: [],
      },
      stepItems: [],
      editable: true,
      listUrl: "",
      popupOptions: {
        isFull: false,
        width: "80%",
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.assessPlan.list.url;
      // code setting
      this.$comm.getStepItems("RAM_RISK_STEP_CD").then((_result) => {
        _result.splice(1, 1);
        this.stepItems = _result;
      });
      this.$set(
        this.searchParam,
        "sopConstructionId",
        this.popupParam.sopConstructionId,
      );
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    linkClick(row) {
      this.popupOptions.title = "위험성평가 상세"; // 위험성평가 상세
      this.popupOptions.param = {
        ramRiskAssessmentPlanId: row.ramRiskAssessmentPlanId,
        ramStepCd: row.ramStepCd,
        vendorFlag: row.vendorFlag > 0,
        ramTechniqueCd: row.ramTechniqueCd,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/ram/riskDetail.vue"}`);
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    deleteTask() {
      let selectData = this.$refs["tasktable"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "안내",
          message: "제외할 행을 지정하세요.", // 제외할 행을 지정하세요.
          type: "warning", // success / info / warning / error
        });
      } else {
        window.getApp.$emit("CONFIRM", {
          title: "확인",
          message: "삭제하시겠습니까?",
          // TODO : 필요시 추가하세요.
          type: "info", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.task.deleteUrl;
            this.$http.type = "DELETE";
            this.$http.param = {
              data: Object.values(
                this.$_.map(selectData, (item) => {
                  return {
                    sopConstructionId: this.popupParam.sopConstructionId,
                    ramRiskAssessmentPlanId: item.ramRiskAssessmentPlanId,
                  };
                }),
              ),
            };
            this.$http.request(() => {
              window.getApp.$emit("APP_REQUEST_SUCCESS");
              this.$refs["tasktable"].$refs["compo-table"].clearSelection();
              this.getList();
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      }
    },
    addTask() {
      this.popupOptions.title = "위험성평가 검색"; // 위험성평가 검색
      this.popupOptions.param = {
        type: "multiple",
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/ram/riskAssessmentPop.vue"}`);
      this.popupOptions.isFull = false;
      this.popupOptions.width = "80%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeTaskPopup;
    },
    closeTaskPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let insertList = [];
        this.$_.forEach(data, (item) => {
          if (
            this.$_.findIndex(this.grid.data, {
              ramRiskAssessmentPlanId: item.ramRiskAssessmentPlanId,
            }) === -1
          ) {
            insertList.push({
              sopConstructionId: this.popupParam.sopConstructionId,
              ramRiskAssessmentPlanId: item.ramRiskAssessmentPlanId,
            });
          }
        });

        this.$http.url = this.task.insertUrl;
        this.$http.type = "POST";
        this.$http.param = insertList;
        this.$http.request(() => {
          window.getApp.$emit("APP_REQUEST_SUCCESS");
          this.getList();
        });
      }
    },
  },
};
</script>
